import React, { ChangeEvent, Component } from "react";
import ICreateCategoryDTO from "../../../../models/DTO/ICreateCategoryDTO";
import IDeleteCategoryDTO from "../../../../models/DTO/IDeleteCategoryDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCategoriesDTO from "../../../../models/DTO/IGetCategoriesDTO";
import IOnCreateCategoryDTO from "../../../../models/DTO/IOnCreateCategoryDTO";
import IOnDeleteCategoryDTO from "../../../../models/DTO/IOnDeleteCategoryDTO";
import IOnGetCategoriesDTO from "../../../../models/DTO/IOnGetCategoriesDTO";
import IOnUpdateCategoryDTO from "../../../../models/DTO/IOnUpdateCategoryDTO";
import IUpdateCategoryDTO from "../../../../models/DTO/IUpdateCategoryDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICategory from "../../../../models/ICategory";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import { OrderCategoryRow } from "../OrderCategoryRow/OrderCategoryRow";
import { Socket } from "socket.io-client";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    createActive: boolean;
    categories: ICategory[];
    name: string;
    addActive: boolean;
};

class OrderCategoriesSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            categories: [],
            name: "",
            addActive: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.CategoriesOnGetCategories, this.onGetCategories);
        this.props.socket.on(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnDeleteCategory, this.onDeleteCategory);

        this.getCategories();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnGetCategories, this.onGetCategories);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnCreateCategory, this.onCreateCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnDeleteCategory, this.onDeleteCategory);
    }

    getCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            onlyRootCategories: true,
            isOrderCategory: true,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetCategories = (data: IOnGetCategoriesDTO) => {
        this.setState({
            categories: data.categories,
        });
    };

    createCategory = () => {
        const payload: ICreateCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isOrderCategory: true,
            name: this.state.name,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesCreateCategory, payload);

        this.setState({
            addActive: true,
        });
    };

    onCreateCategory = (data: IOnCreateCategoryDTO) => {
        this.getCategories();

        this.setState({
            addActive: false,
            name: "",
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {};

    deleteCategory = (category: ICategory) => {
        const payload: IDeleteCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: category.guid,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesDeleteCategory, payload);
    };

    onDeleteCategory = (data: IOnDeleteCategoryDTO) => {
        this.getCategories();
    };

    updateCategory = (category: ICategory) => {
        const payload: IUpdateCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: category.guid,
            name: category.name,
        };

        this.props.socket.emit(EndpointsEnum.CategoriesUpdateCategory, payload);
    };

    onUpdateCategory = (data: IOnUpdateCategoryDTO) => {
        this.getCategories();
    };

    render() {
        return (
            <div className={"OrderCategoriesSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"order_categories"} leftIconName={"fad fa-pencil"} />
                    <hr />
                </div>

                <div className={"col-12"}>
                    <div className={"input-group"}>
                        <OwFnInput noOuterDiv={true} name={"name"} fn={this.handleChange} value={this.state.name} />
                        <OwButton
                            title={"add"}
                            fn={this.createCategory}
                            active={this.state.addActive}
                            disabled={!this.state.name.length}
                            disableOnActive={true}
                        />
                    </div>
                </div>

                <div className={"col-12 mt-4"}>
                    {this.state.categories.map((category, index) => {
                        return (
                            <OrderCategoryRow
                                key={index}
                                category={category}
                                updateCategoryFn={this.updateCategory}
                                deleteCategoryFn={this.deleteCategory}
                                index={index}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default OrderCategoriesSidebar;
